import { render, staticRenderFns } from "./OverduePayments.vue?vue&type=template&id=24cb771c&scoped=true&"
import script from "./OverduePayments.vue?vue&type=script&lang=js&"
export * from "./OverduePayments.vue?vue&type=script&lang=js&"
import style0 from "./OverduePayments.vue?vue&type=style&index=0&id=24cb771c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb771c",
  null
  
)

export default component.exports